module.exports = __webpack_public_path__ + "static/media/1.56b02a25.jpg";